@if (productCodes) {
  <div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
  <wc-wrapper [contentWrapper]="wrapper">
    <wc-base-comparator sd-component-wrapper-component
      [productCodes]="productCodes"
      (hasLoaded)="hasLoaded()"
      [context]="context"
      [brandCorner]="brandCorner"
    />
  </wc-wrapper>
}
